import React from 'react';
import fetch from 'unfetch';
import { string, oneOfType, number, func } from 'prop-types';
import $ from 'jquery';
import Icon from 'components/icon';
import Loader from '../../loader';
import DetailsHeader from './docket-detail/Header';
import DocketCostCode from './docket-detail/DocketCostCode';
import DocketTabs from './docket-detail/Tabs';
import Details from './docket-detail/Details';
import History from './docket-detail/History';
import Files from './docket-detail/Files';
import ImageCarousel from './ImageCarousel';
import QueryForm from './QueryForm';
import Notification from '../../notification/notification';
import { updateOrAddObjectValueInArray } from '../../helpers/generalHelper';
import ErrorMessage from './ErrorMessage';

export default class EdocketDetails extends React.Component {
    constructor(props) {
        super(props);

        const urlState = this.getInitialStateFromURL();

        this.state = {
            edocketDetails: [],
            queryForm: false,
            imageCarouselKey: '',
            imageCarouselFilter: '',
            refresh: false,
            categorizedFiles: {},
            categories: [],
            querySuccess: undefined,
            queryMessage: '',
            isEditingCostcode: false,
            shouldDisplayBottomCostcode: false,
            shouldDisplayCostcodeNotification: false,
            costcodeSubmissionSuccess: false,
            primaryCostCode: '',
            equipmentCostCodes: [],
            equipmentCostCodeEditing: false,
            loadCostCodes: [],
            loadCostCodeEditing: false,
            waitingTimeCostCodes: [],
            waitingTimeCostCodeEditing: false,
            tollCostCodes: [],
            tollCostCodeEditing: false,
            isLoading: false,
            showCloseConfirmation: false,
            primaryCostCodeIsDirty: false,
            equipmentCostCodeIsDirty: false,
            loadCostCodeIsDirty: false,
            waitingTimeCostCodeIsDirty: false,
            tollCostCodeIsDirty: false,
            activeTab: 'details',
            hasApiError: false,
            apiErrorMessage: '',
            showApiErrorNotification: false,
            ...urlState
        };

        this.toggleQueryForm = this.toggleQueryForm.bind(this);
        this.sendApproval = this.sendApproval.bind(this);
        this.shouldShowQueryAndApproveButton = this.shouldShowQueryAndApproveButton.bind(this);
        this.closeImageCarousel = this.closeImageCarousel.bind(this);
        this.displayImageCarousel = this.displayImageCarousel.bind(this);
        this.updateQueryResult = this.updateQueryResult.bind(this);
        this.costcodeActionButtonHandler = this.costcodeActionButtonHandler.bind(this);
        this.costcodeCancelButtonHandler = this.costcodeCancelButtonHandler.bind(this);
        this.scrollToTopAndEditCostCode = this.scrollToTopAndEditCostCode.bind(this);
        this.shouldShowDocketCostCode = this.shouldShowDocketCostCode.bind(this);
        this.escFunction = this.escFunction.bind(this);

        this.submitCostcode = this.submitCostcode.bind(this);
        this.submitCostcodeComplete = this.submitCostcodeComplete.bind(this);
        this.primaryCostCodeChangeHandler = this.primaryCostCodeChangeHandler.bind(this);

        this.equipmentActionButtonHandler = this.equipmentActionButtonHandler.bind(this);
        this.equipmentCancelButtonHandler = this.equipmentCancelButtonHandler.bind(this);
        this.equipmentCostCodeChangeHandler = this.equipmentCostCodeChangeHandler.bind(this);

        this.loadActionButtonHandler = this.loadActionButtonHandler.bind(this);
        this.loadCancelButtonHandler = this.loadCancelButtonHandler.bind(this);
        this.loadCostCodeChangeHandler = this.loadCostCodeChangeHandler.bind(this);

        this.waitingTimeActionButtonHandler = this.waitingTimeActionButtonHandler.bind(this);
        this.waitingTimeCancelButtonHandler = this.waitingTimeCancelButtonHandler.bind(this);
        this.waitingTimeCostCodeChangeHandler = this.waitingTimeCostCodeChangeHandler.bind(this);

        this.tollActionButtonHandler = this.tollActionButtonHandler.bind(this);
        this.tollCancelButtonHandler = this.tollCancelButtonHandler.bind(this);
        this.tollCostCodeChangeHandler = this.tollCostCodeChangeHandler.bind(this);
        this.retryFetchItems = this.retryFetchItems.bind(this);
        this.dismissApiError = this.dismissApiError.bind(this);
    }

    componentDidMount() {
        this.fetchItems();
        document.addEventListener('keydown', this.escFunction, false);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.escFunction, false);
    }

    getInitialStateFromURL() {
        const validTabs = ['details', 'files', 'history'];
        const { hash } = window.location;
        if (hash && hash.startsWith('#tab-')) {
            const tabName = hash.substring(5); // Remove '#tab-' prefix
            if (validTabs.includes(tabName)) {
                return { activeTab: tabName };
            }
        }

        return {};
    }

    setData(data, updatePart) {
        // set max date selection if data exists
        // NOTE! The logic here assumes the data from API is in chronological order
        if (data) {
            const newState = { ...this.state };
            let oldPrimary = '';
            if (updatePart) {
                oldPrimary = newState.edocketDetails.Summary.CostCode;
            }

            // set results & settings
            newState.edocketDetails = data;
            this.toggleQueryForm = this.toggleQueryForm.bind(this);
            if (data.FileItems) {
                const categorizedFiles = this.categorizeFiles(data.FileItems);
                newState.categorizedFiles = categorizedFiles.categorizedFiles;
                newState.categories = categorizedFiles.categories;
            } else {
                newState.categorizedFiles = {};
                newState.categories = [];
            }

            if (data && data.Summary && data.Summary.CostCode && !(newState.primaryCostCode !== '')) {
                newState.primaryCostCode = data.Summary.CostCode;
            }

            if (data.EquipmentItems) {
                let newEquipmentCostCodes = data.EquipmentItems.map(obj => {
                    return { CostCode: obj.CostCode, EquipmentItemID: obj.DraftDocketEquipmentItem_ID };
                });
                newEquipmentCostCodes = newEquipmentCostCodes.filter(obj => (obj.CostCode));
                if (this.state.equipmentCostCodeEditing && this.state.equipmentCostCodeIsDirty) {
                    newState.equipmentCostCodes.forEach(obj => {
                        if (obj.CostCode !== oldPrimary) {
                            updateOrAddObjectValueInArray(newEquipmentCostCodes, 'EquipmentItemID', obj.EquipmentItemID, 'CostCode', obj.CostCode);
                        }
                    });
                }
                newState.equipmentCostCodes = newEquipmentCostCodes;
            }

            if (data.LoadItems) {
                let newLoadCostCodes = data.LoadItems.map(obj => {
                    return { CostCode: obj.CostCode, LoadItemID: obj.LoadID };
                });
                newLoadCostCodes = newLoadCostCodes.filter(obj => (obj.CostCode));
                if (this.state.loadCostCodeEditing && this.state.loadCostCodeIsDirty) {
                    newState.loadCostCodes.forEach(obj => {
                        if (obj.CostCode !== oldPrimary) {
                            updateOrAddObjectValueInArray(newLoadCostCodes, 'LoadItemID', obj.LoadItemID, 'CostCode', obj.CostCode);
                        }
                    });
                }
                newState.loadCostCodes = newLoadCostCodes;
            }

            if (data.WaitingTimeItem && data.WaitingTimeItem.WaitingTimeItems) {
                let newWaitingTimeCostCodes = data.WaitingTimeItem.WaitingTimeItems.map(obj => {
                    return { CostCode: obj.WaitingTimeCostCode, LoadItemID: obj.WaitingTimeID };
                });
                newWaitingTimeCostCodes = newWaitingTimeCostCodes.filter(obj => (obj.CostCode));
                if (this.state.waitingTimeCostCodeEditing && this.state.waitingTimeCostCodeIsDirty) {
                    newState.waitingTimeCostCodes.forEach(obj => {
                        if (obj.CostCode !== oldPrimary) {
                            updateOrAddObjectValueInArray(newWaitingTimeCostCodes, 'LoadItemID', obj.LoadItemID, 'CostCode', obj.CostCode);
                        }
                    });
                }
                newState.waitingTimeCostCodes = newWaitingTimeCostCodes;
            }

            if (data.TollItems) {
                let newTollCostCodes = data.TollItems.map(obj => {
                    return { CostCode: obj.CostCode, TollItemID: obj.DraftDocketTollItem_ID };
                });
                newTollCostCodes = newTollCostCodes.filter(obj => (obj.CostCode));
                if (this.state.tollCostCodeEditing && this.state.tollCostCodeIsDirty) {
                    newState.tollCostCodes.forEach(obj => {
                        if (obj.CostCode !== oldPrimary) {
                            updateOrAddObjectValueInArray(newTollCostCodes, 'TollItemID', obj.TollItemID, 'CostCode', obj.CostCode);
                        }
                    });
                }
                newState.tollCostCodes = newTollCostCodes;
            }

            if (updatePart) {
                newState.shouldDisplayCostcodeNotification = true;
                newState.costcodeSubmissionSuccess = true;

                switch (updatePart.toLowerCase()) {
                    case 'primary': {
                        const isAnyConstCodeEditing = (newState.equipmentCostCodeEditing
                            || newState.loadCostCodeEditing || newState.waitingTimeCostCodeEditing
                            || newState.tollCostCodeEditing);
                        newState.isEditingCostcode = isAnyConstCodeEditing;
                        newState.primaryCostCodeIsDirty = false;
                        break;
                    }
                    case 'equipment': {
                        newState.equipmentCostCodeEditing = false;
                        newState.equipmentCostCodeIsDirty = false;
                        break;
                    }
                    case 'load': {
                        newState.loadCostCodeEditing = false;
                        newState.loadCostCodeIsDirty = false;
                        break;
                    }
                    case 'waitingtime': {
                        newState.waitingTimeCostCodeEditing = false;
                        newState.waitingTimeCostCodeIsDirty = false;
                        break;
                    }
                    case 'toll': {
                        newState.tollCostCodeEditing = false;
                        newState.tollCostCodeIsDirty = false;
                        break;
                    }
                    default:
                        break;
                }

                const {
                    primaryCostCodeIsDirty,
                    equipmentCostCodeIsDirty,
                    loadCostCodeIsDirty,
                    waitingTimeCostCodeIsDirty,
                    tollCostCodeIsDirty
                } = newState;
                const isAnyContentDirty = (primaryCostCodeIsDirty || equipmentCostCodeIsDirty
                    || loadCostCodeIsDirty || waitingTimeCostCodeIsDirty
                    || tollCostCodeIsDirty);
                this.props.updateContentDirty(isAnyContentDirty);
            }

            newState.isLoading = false;

            this.setState(newState);
        }
    }

    escFunction(event) {
        if (event.keyCode === 27) {
            this.props.closeModal(this.state.refresh);
        }
    }

    categorizeFiles(files) {
        const result = {
            categorizedFiles: {},
            categories: []
        };
        files.forEach(item => {
            if (!result.categorizedFiles[item.FileCategory]) {
                result.categorizedFiles[item.FileCategory] = [];
                result.categories.push(item.FileCategory);
            }
            result.categorizedFiles[item.FileCategory].push(item);
        });

        return result;
    }

    toggleQueryForm(refresh = false) {
        const newState = {};
        if (refresh) {
            newState.queryForm = false;
            newState.refresh = true;
            this.fetchItems();
        } else {
            newState.queryForm = !this.state.queryForm;
        }
        this.setState(newState);
    }

    updateQueryResult(message, isSuccess) {
        const newState = {
            edocketDetails: this.state.edocketDetails,
            querySuccess: isSuccess,
            queryMessage: message,
            queryForm: false,
            shouldDisplayBottomCostcode: isSuccess
        };
        if (isSuccess) {
            // newState.edocketDetails.Summary.DraftDocketStatus = 'Client Queried';
            newState.edocketDetails.Summary.DraftDocketStatus = 'Queried';
        }
        this.setState(newState);
    }

    shouldShowQueryAndApproveButton() {
        return (this.state.edocketDetails.Summary.DraftDocketStatus === 'Contractor Submitted'
                    || this.state.edocketDetails.Summary.DraftDocketStatus === 'Submitted');
    }

    shouldShowDocketCostCode() {
        return (this.state.edocketDetails.Summary.DraftDocketStatus === 'Client Approved')
                    || this.state.edocketDetails.Summary.DraftDocketStatus === 'Approved'
                    || (this.state.edocketDetails.Summary.DraftDocketStatus === 'Client Queried')
                    || (this.state.edocketDetails.Summary.DraftDocketStatus === 'Queried')
                    || (this.state.edocketDetails.Summary.DraftDocketStatus === 'Finalised');
    }

    sendApproval() {
        const dataObj = {
            method: 'POST',
            headers: {
                Authorization: this.props.bearerToken,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                refId: this.props.refID,
                DraftDocketGUID: this.state.edocketDetails.Summary.DraftDocketGuid,
                ActionType: 'Approve',
                DraftDocketClientType: this.state.edocketDetails.Summary.DraftDocketClientType
            })
        };
        postData(`${this.props.dataURL}/api/DraftDocketAction`)
            .then(data => {
                this.approvalComplete(data.Success, data.Message);
            });
        this.setState({ isLoading: true });

        function postData(dataUrl = '') {
            return fetch(dataUrl, dataObj)
                .then(response => response.json());
        }
    }

    approvalComplete(success, message) {
        const newState = {
            edocketDetails: this.state.edocketDetails,
            dataApproveMessage: message,
            dataApproveSuccess: success,
            shouldDisplayBottomCostcode: success,
            refresh: success,
            isLoading: false
        };

        if (success) {
            // newState.edocketDetails.Summary.DraftDocketStatus = 'Client Approved';
            newState.edocketDetails.Summary.DraftDocketStatus = 'Approved';
        }
        this.setState(newState);
    }

    fetchItems(updatePart = null) {
        // test with an edocket id that we know we get resultst from 10866 ${this.props.DraftDocketNumber}
        if (this.props.sampleData !== '') {
            const sampleDetailData = this.props.sampleData.trim();
            if (sampleDetailData !== '') {
                const jsonsampleDetailData = JSON.parse(sampleDetailData);
                this.setData(jsonsampleDetailData);
                return;
            }
        }
        const { bearerToken, clientType } = this.props;
        const dataUrl = `${this.props.dataURL}/api/DraftDocketDetail?refId=${this.props.refID}` +
            `&draftDocketId=${this.props.DraftDocketNumber}&clientType=${clientType}`;

        this.setState({
            isLoading: true,
            hasApiError: false,
            showApiErrorNotification: false
        });

        postData(dataUrl)
            .then(data => {
                this.setData(data, updatePart);
                this.setState({
                    hasApiError: false,
                    apiErrorMessage: '',
                    showApiErrorNotification: false,
                    isLoading: false
                });
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    hasApiError: true,
                    apiErrorMessage: error.message || 'Failed to load docket details. Please try again.',
                    showApiErrorNotification: true
                });
            });

        async function postData(url = '') {
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: { Authorization: bearerToken }
                });

                if (!response.ok) {
                    const errorResponse = await response.json();
                    throw new Error(errorResponse.Message || 'Failed to fetch data from server');
                }

                return await response.json();
            } catch (error) {
                throw error;
            }
        }
    }

    retryFetchItems() {
        this.setState({
            hasApiError: false,
            apiErrorMessage: '',
            showApiErrorNotification: false
        });
        this.fetchItems();
    }

    dismissApiError() {
        this.setState({ showApiErrorNotification: false });
        this.props.closeModal(this.state.refresh);
    }

    displayImageCarousel(key, category) {
        this.setState({
            imageCarouselKey: key,
            imageCarouselFilter: category
        });
    }

    closeImageCarousel() {
        this.setState({ imageCarouselKey: '' });
    }

    costcodeActionButtonHandler() {
        if (!this.state.isEditingCostcode) {
            this.setState({ isEditingCostcode: true });
        } else {
            this.submitCostcode('Primary');
        }
    }

    costcodeCancelButtonHandler() {
        const {
            equipmentCostCodeIsDirty,
            loadCostCodeIsDirty,
            waitingTimeCostCodeIsDirty,
            tollCostCodeIsDirty
        } = this.state;
        const isAnyContentDirty = (equipmentCostCodeIsDirty || loadCostCodeIsDirty || waitingTimeCostCodeIsDirty
            || tollCostCodeIsDirty);
        this.props.updateContentDirty(isAnyContentDirty);
        this.setState({ isEditingCostcode: false, primaryCostCodeIsDirty: false });
    }

    primaryCostCodeChangeHandler(costcode) {
        this.props.updateContentDirty(true);
        this.setState({ primaryCostCode: costcode, primaryCostCodeIsDirty: true });
    }

    equipmentActionButtonHandler() {
        if (!this.state.equipmentCostCodeEditing) {
            this.setState({ equipmentCostCodeEditing: true });
        } else {
            this.submitCostcode('Equipment');
        }
    }

    equipmentCancelButtonHandler() {
        const {
            primaryCostCodeIsDirty,
            loadCostCodeIsDirty,
            waitingTimeCostCodeIsDirty,
            tollCostCodeIsDirty
        } = this.state;
        const isAnyContentDirty = (primaryCostCodeIsDirty || loadCostCodeIsDirty || waitingTimeCostCodeIsDirty
            || tollCostCodeIsDirty);
        this.props.updateContentDirty(isAnyContentDirty);
        const initialEquipmentCostCodes = this.state.edocketDetails.EquipmentItems.map(obj => {
            return { CostCode: obj.CostCode, EquipmentItemID: obj.DraftDocketEquipmentItem_ID };
        });
        this.setState({
            equipmentCostCodeEditing: false,
            equipmentCostCodeIsDirty: false,
            equipmentCostCodes: initialEquipmentCostCodes
        });
    }

    equipmentCostCodeChangeHandler(costcode, itemId) {
        const newEquipmentCostCodes = updateOrAddObjectValueInArray(this.state.equipmentCostCodes, 'EquipmentItemID', itemId, 'CostCode', costcode);
        this.props.updateContentDirty(true);
        this.setState({ equipmentCostCodes: newEquipmentCostCodes, equipmentCostCodeIsDirty: true });
    }

    loadActionButtonHandler() {
        if (!this.state.loadCostCodeEditing) {
            this.setState({ loadCostCodeEditing: true });
        } else {
            this.submitCostcode('Load');
        }
    }
    loadCancelButtonHandler() {
        const {
            primaryCostCodeIsDirty,
            equipmentCostCodeIsDirty,
            waitingTimeCostCodeIsDirty,
            tollCostCodeIsDirty
        } = this.state;
        const isAnyContentDirty = (primaryCostCodeIsDirty || equipmentCostCodeIsDirty || waitingTimeCostCodeIsDirty
            || tollCostCodeIsDirty);
        this.props.updateContentDirty(isAnyContentDirty);
        const initialLoadCostCodes = this.state.edocketDetails.LoadItems.map(obj => {
            return { CostCode: obj.CostCode, LoadItemID: obj.LoadID };
        });
        this.setState({ loadCostCodeEditing: false, loadCostCodeIsDirty: false, loadCostCodes: initialLoadCostCodes });
    }

    loadCostCodeChangeHandler(costcode, itemId) {
        const newLoadCostCodes = updateOrAddObjectValueInArray(this.state.loadCostCodes, 'LoadItemID', itemId, 'CostCode', costcode);
        this.props.updateContentDirty(true);
        this.setState({ loadCostCodes: newLoadCostCodes, loadCostCodeIsDirty: true });
    }

    waitingTimeActionButtonHandler() {
        if (!this.state.waitingTimeCostCodeEditing) {
            this.setState({ waitingTimeCostCodeEditing: true });
        } else {
            this.submitCostcode('WaitingTime');
        }
    }

    waitingTimeCancelButtonHandler() {
        const {
            primaryCostCodeIsDirty,
            equipmentCostCodeIsDirty,
            loadCostCodeIsDirty,
            tollCostCodeIsDirty
        } = this.state;
        const isAnyContentDirty = (primaryCostCodeIsDirty || equipmentCostCodeIsDirty || loadCostCodeIsDirty
            || tollCostCodeIsDirty);
        this.props.updateContentDirty(isAnyContentDirty);
        const initialWaitingTimeCostCodes = this.state.edocketDetails.WaitingTimeItems.map(obj => {
            return { CostCode: obj.WaitingTimeCostCode, LoadItemID: obj.WaitingTimeID };
        });
        this.setState({
            waitingTimeCostCodeEditing: false,
            waitingTimeCostCodeIsDirty: false,
            waitingTimeCostCodes: initialWaitingTimeCostCodes
        });
    }

    waitingTimeCostCodeChangeHandler(costcode, itemId) {
        const newWaitingTimeCostCodes = updateOrAddObjectValueInArray(this.state.waitingTimeCostCodes, 'LoadItemID', itemId, 'CostCode', costcode);
        this.props.updateContentDirty(true);
        this.setState({ waitingTimeCostCodes: newWaitingTimeCostCodes, waitingTimeCostCodeIsDirty: true });
    }

    tollActionButtonHandler() {
        if (!this.state.tollCostCodeEditing) {
            this.setState({ tollCostCodeEditing: true });
        } else {
            this.submitCostcode('Toll');
        }
    }

    tollCancelButtonHandler() {
        const {
            primaryCostCodeIsDirty,
            equipmentCostCodeIsDirty,
            loadCostCodeIsDirty,
            waitingTimeCostCodeIsDirty
        } = this.state;
        const isAnyContentDirty = (primaryCostCodeIsDirty || equipmentCostCodeIsDirty || loadCostCodeIsDirty
            || waitingTimeCostCodeIsDirty);
        this.props.updateContentDirty(isAnyContentDirty);
        const initialTollCostCodes = this.state.edocketDetails.TollItems.map(obj => {
            return { CostCode: obj.CostCode, TollItemID: obj.DraftDocketTollItem_ID };
        });
        this.setState({ tollCostCodeEditing: false, tollCostCodeIsDirty: false, tollCostCodes: initialTollCostCodes });
    }

    tollCostCodeChangeHandler(costcode, itemId) {
        const newTollCostCodes = updateOrAddObjectValueInArray(this.state.tollCostCodes, 'TollItemID', itemId, 'CostCode', costcode);
        this.props.updateContentDirty(true);
        this.setState({ tollCostCodes: newTollCostCodes, tollCostCodeIsDirty: true });
    }

    submitCostcode(updatePart = '') {
        const savedPrimaryCostCode = this.state.edocketDetails.Summary.CostCode || '';
        const bodyObj = {
            RefId: this.props.refID,
            eDocketGuid: this.state.edocketDetails.Summary.DraftDocketGuid,
            DraftDocketClientType: this.state.edocketDetails.Summary.DraftDocketClientType,
            CostCode: savedPrimaryCostCode,
            EquipmentItems: [],
            LoadItems: [],
            WaitingTimeItems: [],
            TollItems: []
        };

        switch (updatePart.toLowerCase()) {
            case 'primary':
                bodyObj.CostCode = this.state.primaryCostCode;
                break;
            case 'equipment':
                bodyObj.EquipmentItems = this.state.equipmentCostCodes;
                break;
            case 'load':
                bodyObj.LoadItems = this.state.loadCostCodes;
                break;
            case 'waitingtime':
                bodyObj.WaitingTimeItems = this.state.waitingTimeCostCodes;
                break;
            case 'toll':
                bodyObj.TollItems = this.state.tollCostCodes;
                break;
            default:
                break;
        }

        const dataObj = {
            method: 'POST',
            headers: {
                Authorization: this.props.bearerToken,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(bodyObj)
        };

        postData(`${this.props.dataURL}/api/DraftDocketCostCodeUpdate`)
            .then(data => {
                this.submitCostcodeComplete(updatePart, data.Success);
            });
        this.setState({ isLoading: true });

        function postData(dataUrl = '') {
            return fetch(dataUrl, dataObj)
                .then(response => response.json());
        }
    }

    submitCostcodeComplete(updatePart, success) {
        if (success) {
            this.fetchItems(updatePart);
        } else {
            this.setState({
                shouldDisplayCostcodeNotification: true,
                costcodeSubmissionSuccess: false,
                isLoading: false
            });
        }
    }

    scrollToTopAndEditCostCode() {
        $('.modalData').animate({ scrollTop: 0 }, '500');
        this.setState({ isEditingCostcode: true });
    }

    render() {
        if (this.state.showApiErrorNotification) {
            return (
                <React.Fragment>
                    <ErrorMessage
                        errorMessage={this.state.apiErrorMessage}
                        closeModal={() => this.props.closeModal(this.state.refresh)}
                    />
                </React.Fragment>
            );
        }

        if (!this.state.edocketDetails.Summary) {
            return (
                <div className="edocket-detail-loader">
                    <Loader />
                </div>
            );
        }

        const {
            shouldDisplayCostcodeNotification, costcodeSubmissionSuccess,
            isEditingCostcode, primaryCostCode,
            equipmentCostCodes, equipmentCostCodeEditing,
            loadCostCodes, loadCostCodeEditing,
            waitingTimeCostCodes, waitingTimeCostCodeEditing,
            tollCostCodes, tollCostCodeEditing,
            isLoading, edocketDetails
        } = this.state;
        const primaryCostCodeExist = edocketDetails
                                    && edocketDetails.Summary
                                    && edocketDetails.Summary.CostCode;
        const actionDisabledMessage = edocketDetails
                                    && edocketDetails.Summary
                                    && edocketDetails.Summary.ActionDisabledMessage;

        let topCostcodeTitle = 'Need to update the Cost Code on this docket?';
        let topCostcodeDesc = 'Click the button below to add a cost code to this docket for your reporting purposes.';
        let topCostcodeButtonTitle = 'Add Cost Code';

        if (primaryCostCodeExist) {
            topCostcodeTitle = 'Need to update the Cost Code on this docket?';
            topCostcodeDesc = 'Click the button below to edit your cost code.';
            topCostcodeButtonTitle = 'Update Cost Code';
        }

        const notificationIdCostCode = 'notification-edit-costcode';

        return (
            <React.Fragment>
                <div className="edocket-detail">
                    <DetailsHeader
                        closeModal={() => this.props.closeModal(this.state.refresh)}
                        edocketSummary={this.state.edocketDetails.Summary}
                        dataApproveMessage={this.state.dataApproveMessage}
                        dataApproveSuccess={this.state.dataApproveSuccess}
                    />
                    {this.shouldShowDocketCostCode() &&
                    <React.Fragment>
                        <DocketCostCode
                            editing={isEditingCostcode}
                            title={topCostcodeTitle}
                            desc={topCostcodeDesc}
                            buttonTitle={topCostcodeButtonTitle}
                            primaryCostCode={primaryCostCode}
                            actionButtonHandler={this.costcodeActionButtonHandler}
                            cancelButtonHandler={this.costcodeCancelButtonHandler}
                            primaryCostCodeChangeHandler={this.primaryCostCodeChangeHandler}
                        />
                        {shouldDisplayCostcodeNotification &&
                            <React.Fragment>
                                <Notification
                                    notificationId={notificationIdCostCode}
                                    showCloseButton={false}
                                    className={costcodeSubmissionSuccess ? 'success' : 'error'}
                                    template={costcodeSubmissionSuccess ? 'SUBMIT_COSTCODE_SUCCESS' : 'SUBMIT_COSTCODE_FAILED'}
                                />
                            </React.Fragment>
                        }
                    </React.Fragment>
                    }
                    <DocketTabs
                        activeComponent={this.state.activeTab}
                        componentLabels={{
                            details: 'Details',
                            files: 'Files',
                            history: 'History'
                        }}
                        components={{
                            details: (
                                <Details
                                    edocket={this.state.edocketDetails}
                                    toggleQueryForm={this.toggleQueryForm}
                                    sendApproval={this.sendApproval}
                                    shouldShowQueryAndApprove={this.shouldShowQueryAndApproveButton}
                                    queryForm={(this.state.queryForm &&
                                        <QueryForm
                                            toggleQueryForm={this.toggleQueryForm}
                                            refID={this.props.refID}
                                            DraftDocketGuid={this.state.edocketDetails.Summary.DraftDocketGuid}
                                            DraftDocketClientType={
                                                this.state.edocketDetails.Summary.DraftDocketClientType
                                            }
                                            bearerToken={this.props.bearerToken}
                                            dataURL={this.props.dataURL}
                                            updateQueryResult={this.updateQueryResult}
                                        />
                                    )}
                                    dataApproveMessage={this.state.dataApproveMessage}
                                    dataApproveSuccess={this.state.dataApproveSuccess}
                                    dataQuerySuccess={this.state.querySuccess}
                                    dataQueryMessage={this.state.queryMessage}
                                    primaryCostCode={primaryCostCode}
                                    shouldDisplayBottomCostcode={this.state.shouldDisplayBottomCostcode}
                                    bottomCostCodeButtonHandler={this.scrollToTopAndEditCostCode}
                                    enableCostCodeEdit={isEditingCostcode}
                                    equipmentCostCodes={equipmentCostCodes}
                                    equipmentCostCodeEditing={equipmentCostCodeEditing}
                                    equipmentActionButtonHandler={this.equipmentActionButtonHandler}
                                    equipmentCancelButtonHandler={this.equipmentCancelButtonHandler}
                                    equipmentCostCodeChangeHandler={this.equipmentCostCodeChangeHandler}
                                    loadCostCodes={loadCostCodes}
                                    loadCostCodeEditing={loadCostCodeEditing}
                                    loadActionButtonHandler={this.loadActionButtonHandler}
                                    loadCancelButtonHandler={this.loadCancelButtonHandler}
                                    loadCostCodeChangeHandler={this.loadCostCodeChangeHandler}
                                    waitingTimeCostCodes={waitingTimeCostCodes}
                                    waitingTimeCostCodeEditing={waitingTimeCostCodeEditing}
                                    waitingTimeActionButtonHandler={this.waitingTimeActionButtonHandler}
                                    waitingTimeCancelButtonHandler={this.waitingTimeCancelButtonHandler}
                                    waitingTimeCostCodeChangeHandler={this.waitingTimeCostCodeChangeHandler}
                                    tollCostCodes={tollCostCodes}
                                    tollCostCodeEditing={tollCostCodeEditing}
                                    tollActionButtonHandler={this.tollActionButtonHandler}
                                    tollCancelButtonHandler={this.tollCancelButtonHandler}
                                    tollCostCodeChangeHandler={this.tollCostCodeChangeHandler}
                                    actionDisabledMessage={actionDisabledMessage}
                                />
                            ),
                            files: (<Files
                                categories={this.state.categories}
                                categorizedFiles={this.state.categorizedFiles}
                                showCarousel={this.displayImageCarousel}
                                hideCarousel={this.closeImageCarousel}
                            />),
                            history: (<History
                                edocket={this.state.edocketDetails}
                            />)
                        }}
                    />
                    {
                        this.state.imageCarouselKey !== '' &&
                        <div className="ReactModalPortal react-overlay">
                            <div className="fl-image-carousel">
                                <button onClick={() => this.closeImageCarousel()} className="close-btn">
                                    <Icon glyph="cross" />
                                </button>
                                <ImageCarousel
                                    currentImage={this.state.imageCarouselKey}
                                    docketAttachments={this.state.categorizedFiles[this.state.imageCarouselFilter]}
                                />
                            </div>
                        </div>
                    }
                </div>
                {isLoading &&
                    <div className="docket-detail-loading">
                        <div className="c-loader" />
                    </div>
                }
            </React.Fragment>
        );
    }
}

EdocketDetails.propTypes = {
    DraftDocketNumber: oneOfType([string, number]).isRequired,
    refID: oneOfType([string, number]).isRequired,
    closeModal: func.isRequired,
    bearerToken: string.isRequired,
    dataURL: string.isRequired,
    clientType: string.isRequired,
    sampleData: string.isRequired,
    updateContentDirty: func
};

EdocketDetails.defaultProps = { updateContentDirty: () => {} };
